<template>
  <div class="orders">
    <div class="orders-alert" v-for="(alert, index) in ordersAlerts" :key="'alert-' + index"
      @click="setFilter(alert.orderStatusId, alert.endDate, alert.unreturnedOrders, alert.minPrice, alert.startDate, alert.invoice, alert.statusMaxDate)">{{ alert.message }}</div>
    <div class="box box__comenzi">
      <h2 class="box__title">Comenzi</h2>
      <orderfilter ref="orderFilter" v-on:filterSubmit="filterSubmit" />
    </div>
    <div :class="!isLoading ? 'loading' : ''">
      <orderlist ref="orderList" v-on:changePage="changePage" v-on:refreshPage="refreshPage" :orders="orders" :isAltex="filter.isAltex" :isSameday="filter.CourierId === 6"/>
    </div>
  </div>
</template>

<script>
import orderlist from '@/components/Orders/OrderList.vue';
import orderfilter from '@/components/Orders/OrderFilter.vue';
import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    orderlist,
    orderfilter
  },
  data() {
    return {
      isLoading: false,
      orders: {
        totalPages: 0,
      },
      filter: {
        ToContain: [],
        ToNotContain: [],
        OrderId: "",
        InvoiceNumber: "",
        BorderouNumber: "",
        Term: "",
        MinDate: "2000-10-10",
        MaxDate: "",
        ShippingMethod: 0,
        PaymentMethod: 0,
        CourierId: 0,
        OrderStatusId: 0,
        UE: 0,
        Page: 1,
        Limit: 50,
        Bucuresti: 0,
        Invoice: 0,
        BooksNo: 0,
        stock: 0,
        UnreturnedPayU: 0,
        WOPreorder: 0,
        isAltex: false
      },
      ordersAlerts: []
    }
  },
  async mounted() {
    document.title = "Comenzi - Admin";
   
    var startdate = moment();
    this.filter.MaxDate = startdate.format("YYYY-MM-DD");
    startdate = startdate.subtract(30, "days");
    this.filter.MinDate = startdate.format("YYYY-MM-DD");
    if (this.getParameterByName("grup_id_produse")) this.filter.GroupProductId = this.getParameterByName("grup_id_produse");
    if (this.getParameterByName("grup_cantitati")) this.filter.GroupQuantities = this.getParameterByName("grup_cantitati");
    if (this.getParameterByName("id_stare")) this.filter.OrderStatusId = this.getParameterByName("id_stare");
    if (this.getParameterByName("id_curier")) this.filter.CourierId = this.getParameterByName("id_curier");
    if (this.getParameterByName("grup_zone")) this.filter.groupAreas = this.getParameterByName("grup_zone");
    if (this.getParameterByName("stoc")) this.filter.stock = this.getParameterByName("stoc");
    if (this.getParameterByName("comenzi_compuse")) this.filter.OnlyComplex = this.getParameterByName("comenzi_compuse") == "1" ? true : false;
    this.getAllOrders();
    try {
      this.ordersAlerts = await axios.get(this.baseAdminUrl + 'order/get-alerts').then(x => x.data)
    } catch (err) {
      alert(err);
    }
  },
  methods: {
    getAllOrders() {
      this.$refs.orderList.cleanSelectedIds();
      this.isLoading = false;
      let self = this;
      axios.post(this.baseAdminUrl + 'order', this.filter)
        .then(function (response) {
          self.orders = response.data;
          self.isLoading = true;
        });
    },
    setFilter(orderStatusId, endDate, unreturnedOrders, minPrice, startDate, invoice, statusMaxDate) {
      this.filter.StatusMaxDate = statusMaxDate || null;
      if (unreturnedOrders == true) {
        this.filter.UnreturnedPayU = true;
        this.filter.MinDate = "2023-12-01";
      }
      else {
        this.filter.OrderStatusId = orderStatusId;
        this.filter.MaxDate = endDate;

        if (endDate != null) {
          this.filter.MaxDate = endDate;
        }
        else {
          var startdate = moment();
          this.filter.MaxDate = startdate.format("YYYY-MM-DD");
        }

        if (startDate != null) {
          this.filter.MinDate = startDate;
        }
        else {
          this.filter.MinDate = "2000-01-01";
        }

        if (invoice != null) {
          this.filter.Invoice = invoice;
        }
        else {
          this.filter.Invoice = 0;
        }

        this.filter.MinPrice = minPrice;
      }

      this.$refs.orderFilter.setFilter(this.filter);
      this.filterSubmit(this.filter, true)
    },
    filterSubmit(filter, fromAlert) {
      // StatusMaxDate has a value only when filtering from alerts
      if (!fromAlert){
         filter.StatusMaxDate = null;
      }
      this.filter = filter;
      this.getAllOrders();
    },
    changePage(item) {
      this.filter.Page = item;
      this.getAllOrders();
    },
    refreshPage() {
      this.getAllOrders();
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
};
</script>

<style scoped>
.orders {
  padding: 10px;
}

.orders-alert {
  background-color: red;
  padding: 4px;
  color: white;
  font-size: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  cursor: pointer;
}
</style>